import { aggPropsToDto as aggPropsToDto$1 } from "@project-rouge/rg-core";
import { getRgVersions } from "./index79.js";
function aggPropsToDto(raw) {
  return aggPropsToDto$1({ raw, versions: getRgVersions() });
}
export {
  aggPropsToDto
};
//# sourceMappingURL=index31.js.map
